import { z } from 'zod'

import { conditionOperations } from './conditionOperation'

const questionFilterSchema = z.object({
  category: z.literal('Question'),
  question: z.object({
    surveyGroupQuestionId: z.string(),
    operation: z.enum(conditionOperations),
    answerOptions: z
      .array(z.object({ option: z.string(), text: z.string() }))
      .min(1),
  }),
})

const customerAttributeFilterSchema = z.object({
  category: z.literal('CustomerAttribute'),
  customerAttribute: z.object({
    surveyGroupCustomerAttributeGroupId: z.string(),
    operation: z.enum(conditionOperations),
    customerAttributes: z
      .array(z.object({ idLike: z.string(), name: z.string() }))
      .min(1),
  }),
})

const brandSegmentsFilterSchema = z.object({
  category: z.literal('BrandSegments'),
  brandSegments: z.object({
    surveyGroupBrandId: z.string(),
    segmentNumbers: z.array(z.number()).min(1),
  }),
})

const surveyGroupFilterSchema = z.discriminatedUnion('category', [
  questionFilterSchema,
  customerAttributeFilterSchema,
  brandSegmentsFilterSchema,
])

export type SurveyGroupFilterItem = z.infer<typeof surveyGroupFilterSchema>

const surveyGroupFilterGroupSchema = z.array(surveyGroupFilterSchema).min(1)

export const surveyGroupFilterGroupsSchema = z.array(
  surveyGroupFilterGroupSchema,
)

export type SurveyGroupFilterGroups = z.infer<
  typeof surveyGroupFilterGroupsSchema
>
